// extracted by mini-css-extract-plugin
export default {"cell":"SavingTable__cell","clickable":"SavingTable__clickable brandColor__font","noSaving":"SavingTable__noSaving","footnote":"SavingTable__footnote"};